<app-topbar></app-topbar>
<app-sidebar></app-sidebar>
<div class="app-content content">
  <div class="content-wrapper">
    <div class="content-header">
      <div class="page-head">
        <div>
          <h3 class="page-head__title">Daily Dollar Exchange Rate</h3>
          <p class="page-head__sub">Daily dollar exchange rates uploaded by IMTO partners.</p>
        </div>
        <div class="page-head__tools">
          <span class="page-pill">
            <i class="fa fa-usd"></i> {{ dailyRates?.length }} rates
          </span>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="card">
            @if (permission !== 'admin') {
              <div
                class="card-header card-toolbar"
                >
                <h4 class="card-toolbar__title">
                  <i class="fa fa-usd"></i> Exchange Rates
                  <span class="count-pill">{{ dailyRates?.length }}</span>
                </h4>
                <div class="card-toolbar__actions">
                  <app-dollar-rate-modal
                    (refreshRates)="getDollarRates()"
                  ></app-dollar-rate-modal>
                </div>
              </div>
            }
            <div class="card-content">
              <div class="table-responsive hover">
                @if (dailyRates?.length > 0) {
                  <table
                    class="table table-de mb-0"
                    >
                    <thead>
                      <tr>
                        <th (click)="sortOrders('transaction_ref')" tabindex="0" (keydown.enter)="sortOrders('transaction_ref')" (keydown.space)="sortOrders('transaction_ref')">
                          Exchange Rate per USD
                        </th>
                        @if (permission !== 'admin') {
                          <th
                            (click)="sortOrders('agent')"
                            >
                            Uploader
                          </th>
                        }
                        @if (permission !== 'admin') {
                          <th
                            (click)="sortOrders('payout_amount')"
                            >
                            Approver
                          </th>
                        }
                        <th (click)="sortOrders('created_at')" tabindex="0" (keydown.enter)="sortOrders('created_at')" (keydown.space)="sortOrders('created_at')">Status</th>
                        <th (click)="sortOrders('status')" tabindex="0" (keydown.enter)="sortOrders('status')" (keydown.space)="sortOrders('status')">Upload Date</th>
                        <th (click)="sortOrders('message')" tabindex="0" (keydown.enter)="sortOrders('message')" (keydown.space)="sortOrders('message')">Approval Date</th>
                        <th (click)="sortOrders('message')" tabindex="0" (keydown.enter)="sortOrders('message')" (keydown.space)="sortOrders('message')">Valid to</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      @for (item of dailyRates | paginate : config; track item) {
                        <tr
                          class="pull-up myBox"
                          [routerLink]="['/dollar-rate', $safeNavigationMigration(item?.id)]"
                          >
                          <td>₦{{ $safeNavigationMigration(item?.rate) | number : "1.2-2" }}</td>
                          @if (permission !== 'admin') {
                            <td>
                              {{ item?.uploader?.name }}
                            </td>
                          }
                          @if (permission !== 'admin') {
                            <td>
                              {{ item?.approver?.name }}
                            </td>
                          }
                          <td>
                            <span
                              class="status-badge status-{{ item?.status }}"
                              >
                              {{ item?.status }}
                            </span>
                          </td>
                          <td>{{ $safeNavigationMigration(item?.created_at) | date }}</td>
                          <td>{{ $safeNavigationMigration(item?.approved_at) | date }}</td>
                          @if (item.valid_to) {
                            <td>
                              {{ $safeNavigationMigration(item?.valid_to) | date : "yyyy-MM-dd HH:mm:ss" }}
                              GMT(+1)
                            </td>
                          }
                          @if (!item.valid_to) {
                            <td></td>
                          }
                          <td class="details">
                            <a
                              [routerLink]="['/dollar-rate', $safeNavigationMigration(item?.id)]"
                              class="details"
                              >Details </a
                              ><i class="icons icon-leftt"></i>
                            </td>
                          </tr>
                        }
                      </tbody>
                    </table>
                  }
                  <div>
                    <pagination-controls
                      (pageChange)="pageChanged($event)"
                    ></pagination-controls>
                  </div>
                  @if (dailyRates?.length === 0) {
                    <div
                      class="empty-state"
                      >
                      {{ emptyTransactionMessage }}
                    </div>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <app-bottombar></app-bottombar>
